import { Module, Payload } from 'vuex';
import { RootStoreState } from '@/store';

export interface UserGroupStoreState {
  selectedUserGroup: any;
  hoveredUserGroup: any;
  addUserFlag: boolean;
  initialSelectedList: [];
  affiliateGroups: any[];
  userGroupResponseCopy: any[];
}

export interface StoreUserGroupManagement extends Partial<Payload> {
  selectedUserGroup: any;
  hoveredUserGroup: UserGroupStoreState['hoveredUserGroup'];
}

export const MUTATION_SELECT_USER_GROUP = 'userGroupSelected';
export const MUTATION_HOVER_USER_GROUP = 'userGroupHovered';

export default {
  state: {
    selectedUserGroup: [],
    registerProductView: false,
    hoveredUserGroup: [],
    addUserFlag: false,
    initialSelectedList: [],
    affiliateGroups: [],
    userGroupResponseCopy: [],
  },
    /*tslint:disable:function-name */
  mutations: {
    [MUTATION_SELECT_USER_GROUP](state, payload) {
      state.selectedUserGroup = payload;
    },
    [MUTATION_HOVER_USER_GROUP](state, payload) {
      state.hoveredUserGroup = payload;
    },
    mutate: (state:any , payload) => state[payload.property] = payload.with,
    setAffiliateGroups: (state: any, payload) => state.affiliateGroups = payload,
    setUserGroupResponseCopy(state: any, payload) {
      state.userGroupResponseCopy = JSON.parse(JSON.stringify(payload));
    },
  },
  getters: {
    getSelectedUserGroup(state: any) {
      return state.selectedUserGroup;
    },
    getHoveredUserGroup(state: any) {
      return state.hoveredUserGroup;
    },
    getAddUserFlagState(state: any) {
      return state.addUserFlag;
    },
    getInitialCustomersList: state => state.initialSelectedList,
    getAffiliateGroupArray: state => state.affiliateGroups,
    getUserGroupResponseCopy: state => state.userGroupResponseCopy,
  },
  actions: {
    userGroupSelected({ commit }, payload) {
      commit(MUTATION_SELECT_USER_GROUP, payload);
    },
    userGroupHovered({ commit }, payload) {
      commit(MUTATION_HOVER_USER_GROUP, payload);
    },
  },
  namespaced: true,
    /*tslint:enable:function-name */
} as Module<UserGroupStoreState, RootStoreState>;
